import merge from 'lodash/merge';
import mergeDeep from '@utils/mergeDeep';
import { itemTypes, classTypes, savedTypes, courseTypes } from '../constants';

const initialState = {
  data: {},
  isFetchingSchedule: false,
  scheduledClasses: {},
  calendarData: {},
  classes: {},
  freeRelatedLessons: {},
  isClassModalOpened: false,
  isLessonsFetched: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case itemTypes.UPDATE_ITEMS:
      return {
        ...state,
        data: mergeDeep(action.data, state.data, 2)
      };

    case `${courseTypes.FETCH_FREE_COURSE_ITEM}_SUCCESS`:
      return {
        ...state,
        isLessonsFetched: true
      };
    case `${courseTypes.FETCH_FREE_COURSE_ITEM}_REQUEST`:
      return {
        ...state,
        isLessonsFetched: false
      };
    case `${classTypes.FETCH_CLASS}_SUCCESS`:
      return {
        ...state,
        classes: {
          ...state.classes,
          [action.uid]: action.result
        }
      };

    case `${itemTypes.FETCH_FREE_LESSON_INFO}_SUCCESS`:
      return {
        ...state,
        classes: {
          ...state.classes,
          [action.uid]: action.result
        }
      };

    case `${itemTypes.FETCH_FREE_LESSON_LIST}_SUCCESS`:
      return {
        ...state,
        freeRelatedLessons: {
          ...state.freeRelatedLessons,
          [action.uid]: action.result?.results
        }
      };

    case `${itemTypes.BOOKMARK_ITEM}_SUCCESS`:
      return {
        ...state,
        data: {
          ...state.data,
          [action.uid]: merge(state.data[action.uid], {
            isBookmarked: action.isBookmarked
          })
        }
      };

    case `${classTypes.FETCH_SIMILAR_AND_OTHER_COURSES}_SUCCESS`:
      return {
        ...state,
        similarAndOtherCourses: {
          ...state.similarAndOtherCourses,
          [action.uid]: action.result
        }
      };

    case `${classTypes.FETCH_SCHEDULED_CLASSES}_REQUEST`:
      return {
        ...state,
        isFetchingSchedule: true,
        scheduledClasses: action.resetWithoutEmpty
          ? null
          : state.scheduledClasses
      };

    case `${classTypes.FETCH_SCHEDULED_CLASSES}_SUCCESS`:
      return {
        ...state,
        isFetchingSchedule: false,
        scheduledClasses: action.resetWithoutEmpty
          ? {
              [action.key]: action.result
            }
          : {
              ...state.scheduledClasses,
              [action.key]:
                state.scheduledClasses[action.key] && action.result
                  ? {
                      previous:
                        action.direction === 'down'
                          ? state.scheduledClasses[action.key].previous
                          : action.result.previous,
                      next:
                        action.direction === 'up'
                          ? state.scheduledClasses[action.key].next
                          : action.result.next,
                      results:
                        action.direction === 'down'
                          ? [
                              ...state.scheduledClasses[action.key].results,
                              ...action.result.results
                            ]
                          : [
                              ...action.result.results,
                              ...state.scheduledClasses[action.key].results
                            ]
                    }
                  : action.result
            }
      };

    case `${classTypes.FETCH_CALENDAR_DATA}_SUCCESS`:
      return {
        ...state,
        calendarData: {
          ...state.calendarData,
          [action.month]: action.result
        }
      };

    case 'CLASS_MODAL_OPEN': {
      return {
        ...state,
        isClassModalOpened: true
      };
    }

    case 'CLASS_MODAL_CLOSE': {
      return {
        ...state,
        isClassModalOpened: false
      };
    }

    case `${classTypes.SEND_WATCHED}_SUCCESS`:
      return {
        ...state,
        data: {
          ...state.data,
          [action.uid]: mergeDeep(state.data[action.uid], {
            watched: true
          })
        }
      };

    case `${savedTypes.REMOVE_SAVED_ENTITY}_SUCCESS`: {
      const { objectUid } = action;
      if (!state.data[objectUid]) return state;
      return {
        ...state,
        data: {
          ...state.data,
          [objectUid]: {
            ...state.data[objectUid],
            isSaved: false
          }
        }
      };
    }

    case `${savedTypes.SAVE_ENTITY}_SUCCESS`: {
      const { objectUid } = action;
      if (!state.data[objectUid]) return state;
      return {
        ...state,
        data: {
          ...state.data,
          [objectUid]: {
            ...state.data[objectUid],
            isSaved: true
          }
        }
      };
    }

    default:
      return state;
  }
};

export default reducer;
